//'use strict';

//list out the vars
var mOverlay = getClass('modal-overlay'),
    allNodes = document.querySelectorAll("*"),
    modalOpen = false,
    lastFocus,
    i;

//Let's cut down on what we need to type to get an ID
function getClass(cl) {
    return document.getElementsByClassName(cl)[0];
}

// Let's open the modal
function modalShow() {
    lastFocus = document.activeElement;
    $('.modal-overlay').attr('aria-hidden', 'false');
    modalOpen = true;
    $('.modal-content').attr('tabindex', '0');
    $('.modal-content').focus();
}

var modal = '', modalID = '';
function modalShowId(id, isShowCloseBtn = false) {
    lastFocus = document.activeElement;
    if(isShowCloseBtn){
        $(id).addClass('show-close-btn');
    }
    $(id).attr('aria-hidden', 'false');
    $(id).attr('backdrop', 'static');
    modalOpen = true;
    $(id).attr('data-backdrop', 'static');
    $(id).attr('tabindex', '-1');
    $('.modal-content').attr('tabindex', '0');
    $('.modal-content').focus();
    $(id).find('.modal-content').focus();
    $('body, html').css('overflow', 'hidden');
    if ($(id + " .btn-close").length && $(id + " .btn-good").length) {
        lockKeyboardTraversal(id + " .btn-close", id + " .btn-good");
    }
    subwayScript.hideSpinner();
    subwayScript.hideSpinner1();
    $(".btn").removeAttr("title");
    if ($(window).width() > 1023) {    
        modal = document.querySelector("" + id + " .modal-tc");        
    } else {
        modal = document.querySelector("" + id + " .modal-table");
    }
    if(!modal){
        $('body, html').css('overflow', 'initial');
    }
}
$(document).on('click', '#location-modal', function (e) {
    $(this).closest('.modal-overlay').attr('aria-hidden', 'true');
    $(this).closest('.modal-content').attr('tabindex', '-1');
    $('#modal-location-missing').attr('aria-hidden', 'true');
    $('#modal_locationerror-holder').attr('tabindex', '-1');
});

// binds to both the button click and the escape key to close the modal window
// but only if modalOpen is set to true
function modalClose(event, isRedirectToLocator,isRedirectToHome) {
     // Check if the subclub modal is the currently visible modal
    var subclubModal = document.querySelector('#subclub-rewards-modal');
    var isSubclubModalVisible = subclubModal && subclubModal.getAttribute('aria-hidden') !== 'true';
    
    if (modalOpen && (!event || (!event.keyCode && event.keyCode !== 0) || event.keyCode === 27)) {
        // If ESC key is pressed and subclub modal is visible, don't close it
        if (event && event.keyCode === 27 && isSubclubModalVisible) {
            return; // Exit early, don't close the subclub modal
        }
        setTimeout(function () { analytics.closeModal(); },500)
        var locationClose = document.querySelector(".location-close");
        var locatorUrl = locationClose && locationClose.getAttribute("data-url")
        if (isRedirectToLocator && !locatorUrl) {
         if (window.location.pathname.toLowerCase() != subwayScript.navigation.getLocatorUrl().toLowerCase()) {
                $('#subway-spinner').show();
                const redirectUrl = subwayScript.navigation.getLocatorUrl();
                setTimeout(() => {
                    window.location.href = redirectUrl;
                }, 1000);
            }
        }

        if(locatorUrl){
            const currentPath = window.location.pathname.toLowerCase();
            const validPaths = [
            subwayScript.navigation.getLocatorUrl().toLowerCase(),
            subwayScript.navigation.getDeliveryLocatorUrl().toLowerCase()
            ];

            if (!validPaths.includes(currentPath)) {
                $('#subway-spinner').show();
                const redirectUrl = locatorUrl || subwayScript.navigation.getLocatorUrl();
                setTimeout(() => {
                    window.location.href = redirectUrl;
                }, 1000);
            }
        }
        if (isRedirectToHome) {
            window.location.href = window.location.origin + subwayScript.navigation.getLanguageCode();
        }
        $('.modal-overlay').attr('aria-hidden', 'true');
        $('.modal-content').attr('tabindex', '-1');

        if ($('#modal-error .btn-good').text() != "OK") {
            $('#modal-error .btn-good').text("OK");
        }
        
        modalOpen = false;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer
        {
            $('body, html').css('overflow', '');
        }
        else // If another browser
        {
            $('body, html').css('overflow', 'initial');
        }
        lastFocus.focus();
    }
}



//Restrict focus to the modal window when it's open.
//Tabbing will just loop through the whole modal.
//Shift + Tab will allow backup to the top of the modal,
//and then stop.
function focusRestrict(event) {
    var modal = document.getElementsByClassName('modal-content')[0];
    if (modalOpen && modal && !modal.contains(event.target)) {
        event.stopPropagation();
        modal.focus();
    }
}

if (typeof mOverlay != "undefined") {
    //Close modal window by clicking on the overlay
    mOverlay.addEventListener('click',
        function (e) {
            var modal = document.getElementsByClassName('modal-table')[0];
            if (e.target == modal.parentNode) {
                modalClose(e);
                $(".picker-ingredient").removeClass("inactive active-picker");
            }
        },
        false);
}

// close modal by keydown, but only if modal is open
document.addEventListener('keydown', modalClose);

// //restrict tab focus on elements only inside modal window
for (i = 0; i < allNodes.length; i++) {
    allNodes.item(i).addEventListener('focus', focusRestrict);
}
/* Locks keyboard traversal between the two given ids */
function lockKeyboardTraversal(startingId, endingId) {
    $(endingId).on('keydown', function (e) {
        var keyCode = e.keyCode || e.which;
        if (!e.shiftKey && keyCode == keyCodes.TAB) {
            e.preventDefault();
            $(startingId).focus();
        }
    });
    $(startingId).on('keydown', function (e) {
        var keyCode = e.keyCode || e.which;
        if (e.shiftKey && e.keyCode == keyCodes.TAB) {
            e.preventDefault();
            $(endingId).focus();
        }
    });
    $(startingId).focus();
}

$(window).resize(function (e) {
    setTimeout(function () {
        if ($(window).width() < 1024) {
            $('.modal-overlay[aria-hidden="false"]').each(function (i, obj) {
                if(!$(".modal-overlay").find(".overlayModal").length) {
                    $("html").css("overflow-y", "hidden");
                }
            });
        }
    }, 500);
});